export default "data:image/gif;base64,R0lGODlhEAAQAIABAAAAAP///yH5BAEKAAEALAAAAAAQABAAAAIWjI+py30Ao5zA2YsN3TH7/3AbSJZOAQA7"